var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnisat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14102_2711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: -1,
    width: 20,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 -0.000366211H2.25V23.9996H21.375V-0.000366211Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14102_2711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7402 2.15914L20.7473 7.03715C21.1735 7.45148 21.3833 7.87073 21.3767 8.29321C21.3701 8.71568 21.1867 9.10077 20.8283 9.45012C20.4533 9.81575 20.0485 10.001 19.6157 10.0091C19.1829 10.0156 18.7534 9.81087 18.3271 9.39653L13.206 4.40802C12.6245 3.84095 12.0628 3.43958 11.5227 3.20396C10.9824 2.96835 10.4142 2.93098 9.81944 3.09347C9.22308 3.25434 8.58378 3.66869 7.89821 4.3349C6.95328 5.25623 6.50227 6.12068 6.54854 6.92828C6.59478 7.73585 7.06394 8.57431 7.95438 9.44041L13.1168 14.4711C13.548 14.8904 13.7594 15.3096 13.7528 15.7256C13.7462 16.1432 13.5612 16.5283 13.1961 16.8841C12.8327 17.2383 12.4312 17.4236 11.9951 17.4382C11.559 17.4528 11.1245 17.2497 10.695 16.8305L5.68784 11.9525C4.87342 11.1596 4.28531 10.4088 3.92353 9.70036C3.56174 8.99191 3.42628 8.19083 3.52044 7.29713C3.60469 6.5318 3.85414 5.79083 4.27044 5.07263C4.68509 4.3544 5.2798 3.61994 6.05129 2.86761C6.96978 1.97228 7.84698 1.28657 8.68289 0.808839C9.51716 0.331115 10.3249 0.0662533 11.1047 0.0110063C11.8861 -0.0442408 12.6559 0.108501 13.4175 0.469231C14.179 0.829963 14.9522 1.39218 15.7385 2.15914H15.7402Z",
    fill: "url(#paint0_linear_14102_2711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8848 21.8417L2.87931 16.9637C2.4531 16.5478 2.2433 16.1302 2.24991 15.7077C2.25652 15.2852 2.43989 14.9001 2.79836 14.5507C3.17336 14.1851 3.5781 13.9999 4.01092 13.9918C4.44374 13.9853 4.87325 14.1884 5.29947 14.6044L10.4189 19.5929C11.0021 20.1599 11.5621 20.5613 12.1023 20.7969C12.6425 21.0325 13.2108 21.0683 13.8072 20.9074C14.4035 20.7466 15.0428 20.3322 15.7284 19.6643C16.6734 18.743 17.1244 17.8786 17.0781 17.071C17.0318 16.2634 16.5627 15.4249 15.6723 14.5573L12.9217 11.9005C12.4906 11.4813 12.2791 11.062 12.2857 10.6461C12.2923 10.2285 12.4773 9.84335 12.8424 9.48752C13.2059 9.13325 13.6073 8.94804 14.0434 8.93342C14.4795 8.91879 14.914 9.12189 15.3435 9.54114L17.9371 12.0451C18.7516 12.8381 19.3397 13.5888 19.7015 14.2973C20.0632 15.0057 20.1987 15.8068 20.1045 16.7005C20.0203 17.4658 19.7708 18.2068 19.3545 18.925C18.9399 19.6432 18.3452 20.3777 17.5737 21.13C16.6552 22.0253 15.778 22.7111 14.9421 23.1888C14.1062 23.6665 13.2984 23.933 12.517 23.9882C11.7356 24.0435 10.9658 23.8907 10.2042 23.53C9.44263 23.1693 8.66949 22.6071 7.88315 21.8401L7.8848 21.8417Z",
    fill: "url(#paint1_linear_14102_2711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0071 9.25512C12.0226 9.25512 12.8458 8.44542 12.8458 7.44657C12.8458 6.44776 12.0226 5.63806 11.0071 5.63806C9.99166 5.63806 9.16846 6.44776 9.16846 7.44657C9.16846 8.44542 9.99166 9.25512 11.0071 9.25512Z",
    fill: "url(#paint2_radial_14102_2711)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14102_2711",
    x1: 19.9238,
    y1: 5.00108,
    x2: 4.49189,
    y2: 11.9733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14102_2711",
    x1: 4.13006,
    y1: 19.2008,
    x2: 22.0629,
    y2: 13.7747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4FB52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14102_2711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0071 7.44822) scale(1.83866 1.80853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211C1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisat);
export default __webpack_public_path__ + "static/media/unisat.234c288d07a660e63069994fc215fd28.svg";
export { ForwardRef as ReactComponent };